import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Typography } from '@tkww/the-bash-frontend';

import { SectionContainer } from 'components/grid';
import background from 'public/images-next/plannerValueProposition/background.svg';

const StyledTypography = styled(Typography)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  marginRight: 'auto',
  marginLeft: 'auto',
}));

const BookingIsBetter = () => (
  <SectionContainer
    sx={{ pt: 12, pb: { xs: 10, md: 12 }, backgroundImage: `url(${background})` }}
    containerProps={{
      sx: {
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: '57px',
        justifyContent: 'center',
      },
    }}
  >
    <Box
      component="img"
      width={170}
      height={160}
      display={{ xs: 'none', md: 'initial' }}
      src="/images-next/guarantee-page/book-now-desktop.svg"
    />
    <Box component="section" textAlign={{ xs: 'center', md: 'initial' }} maxWidth={717}>
      <StyledTypography variant="h2" mt={0}>
        Booking is Better on The Bash
      </StyledTypography>
      <Box
        component="img"
        width={170}
        height={160}
        mb={4}
        display={{ xs: 'initial', md: 'none' }}
        src="/images-next/guarantee-page/book-now-mobile.svg"
      />
      <StyledTypography variant="body1">
        Ready to book? Just look for the blue “Book Now” button in your quote email or in your
        account. Book and pay to secure your booking and you’ll be covered by our booking benefits.
        It’s that easy!
      </StyledTypography>
    </Box>
  </SectionContainer>
);

export default BookingIsBetter;
